import { UnitType } from '@exodus/currency'

const name = 'decred'
const displayName = 'Decred'
const ticker = 'DCR'
const displayTicker = 'DCR'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#47D7B6'
const gradientColors = ['#47D7B6', '#5766F2']
const gradientCoords = { x1: '102%', y1: '101%', x2: '0%', y2: '0%' }
const chainBadgeColors = gradientColors

const units = {
  atom: 0,
  DCR: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://mainnet.decred.org/address/${address}`,
  txUrl: (txId) => `https://mainnet.decred.org/tx/${txId}`,
}
const info = {
  description:
    'Decred addresses cryptocurrency problems like conflicts of interest, inefficient governance, and chain splits. DCR is self-funded, governed by stakeholders who are incentivized to vote with DCR rewards, and has a clear governance model that prevents long disputes that can lead to splits.',
  reddit: 'https://www.reddit.com/r/decred/',
  twitter: 'https://twitter.com/decredproject',
  website: 'https://decred.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
